/* Propuesta de color para la reunión del martes 2026-10-06.
   Aplica una de las 4 gamas sobre la página: ?paleta=ritual|monte|bodega|cordillera (se recuerda en este navegador).
   Los colores de cada tintura NO cambian: están impresos en las etiquetas. */
(function () {
  // Modelos con la paleta del MANUAL DE MARCA (BrandBook, Drive): base Verde #4F543E · Crema #FFFAE5 · Negro #1A1A18 · Crema oscuro #EAE6D3
  // + colores de producto Cordyceps #E49444 · Ashwagandha #6D8469 · Reishi #6E2933 · Orégano #2A5B30 · Ginseng #B17E2F · Melena #E9D8BF.
  // Cambia solo QUÉ color hace cada papel (fondos oscuros, bandas, acento, resaltado); no se inventa ningún color. 2026-10-06.
  const MODELOS = ['brandbook', 'monte', 'organico', 'botanico', 'reishi'];
  const PALETAS = {
    // Elegida por Efraín 2026-10-06: sacada de la página "Paleta de colores" del BrandBook (barra verde, texto negro, fotos de hongos).
    // Verde principal #4F543E (barra lateral) · fondo blanco cálido · texto negro · detalles del color de las fotos:
    // ámbar del reishi #D07B19, óxido #A75212, arena #DBC194, piedra #D8CDC4, hueso #E8E2CB, rosa del menú #ECC3B9.
    brandbook: { nombre: 'Brandbook (foto)', vars: {
      // verdes en 4 tonos (oscuro · principal · ashwagandha · pálido) + cordyceps #E49444 para los detalles (pedido 2026-10-06)
      '--verde': '#4F543E', '--verde-osc': '#3A3E2D', '--verde-2': '#6D8469', '--verde-palido': '#E4E7DA',
      '--crema': '#FBF9F4', '--crema-osc': '#E4E7DA', '--negro': '#1A1A18',
      '--card': '#FFFFFF', '--linea': '#CBD0BF', '--gris': '#EEF0E7', '--blanco': '#FFFFFF',
      '--acento': '#E49444', '--sobre-acento': '#1A1A18',
      '--banda-bg': '#3A3E2D', '--banda-txt': '#FBF9F4', '--banda2-bg': '#6D8469',
      '--resalte-bg': '#4F543E', '--resalte-txt': '#FBF9F4',
      '--resalte-hero-bg': '#FBF9F4', '--resalte-hero-txt': '#4F543E',
      '--detalle': '#E49444', '--estrellas': '#E49444', '--oxido': '#A75212', '--arena': '#DBC194' } },
    monte: { nombre: 'Manual', vars: {} },
    organico: { nombre: 'Negro orgánico', vars: {
      '--verde': '#1A1A18', '--verde-osc': '#1A1A18', '--crema': '#FFFAE5', '--crema-osc': '#EAE6D3', '--negro': '#1A1A18',
      '--acento': '#E49444', '--sobre-acento': '#1A1A18',
      '--banda-bg': '#1A1A18', '--banda-txt': '#FFFAE5', '--resalte-bg': '#E49444', '--resalte-txt': '#1A1A18' } },
    botanico: { nombre: 'Botánico', vars: {
      '--verde': '#2A5B30', '--verde-osc': '#2A5B30', '--crema': '#FFFAE5', '--crema-osc': '#EAE6D3', '--negro': '#1A1A18',
      '--acento': '#B17E2F', '--sobre-acento': '#FFFAE5',
      '--banda-bg': '#6D8469', '--banda-txt': '#FFFAE5', '--resalte-bg': '#6D8469', '--resalte-txt': '#FFFAE5' } },
    reishi: { nombre: 'Reishi', vars: {
      '--verde': '#6E2933', '--verde-osc': '#6E2933', '--crema': '#FFFAE5', '--crema-osc': '#E9D8BF', '--negro': '#1A1A18',
      '--acento': '#B17E2F', '--sobre-acento': '#FFFAE5',
      '--banda-bg': '#6E2933', '--banda-txt': '#FFFAE5', '--resalte-bg': '#E9D8BF', '--resalte-txt': '#6E2933' } },               // el manual de marca tal cual (valores por defecto del CSS)
    ritual: { nombre: 'Ámbar', vars: {
      '--verde': '#4F543E', '--verde-osc': '#2E3226', '--crema': '#FFFAE5', '--crema-osc': '#EAE6D3',
      '--negro': '#1A1A18', '--card': '#FFFCEF', '--linea': '#D4CEB7', '--gris': '#F1EEE3', '--blanco': '#FFFDF6',
      '--acento': '#D9A441', '--sobre-acento': '#1A1A18',
      '--banda-bg': '#2E3226', '--banda-txt': '#FFFAE5', '--resalte-bg': '#D9A441', '--resalte-txt': '#1A1A18' } },
    bodega: { nombre: 'Bodega', vars: {
      '--verde': '#4A1822', '--verde-osc': '#33101A', '--crema': '#FBF4E6', '--crema-osc': '#EFE3CF',
      '--negro': '#1F1416', '--card': '#FEF9EE', '--linea': '#DCCBB0', '--gris': '#F3EADA', '--blanco': '#FFFBF3',
      '--acento': '#C9A24A', '--sobre-acento': '#1F1416',
      '--banda-bg': '#4A1822', '--banda-txt': '#FBF4E6', '--resalte-bg': '#C9A24A', '--resalte-txt': '#1F1416' } },
    cordillera: { nombre: 'Cordillera', vars: {
      '--verde': '#262A1E', '--verde-osc': '#16190F', '--crema': '#F7F3E6', '--crema-osc': '#E6E1CF',
      '--negro': '#15170F', '--card': '#FBF8EE', '--linea': '#D2CCB6', '--gris': '#EEEADB', '--blanco': '#FDFBF4',
      '--acento': '#D9F24F', '--sobre-acento': '#15170F',
      '--banda-bg': '#D9F24F', '--banda-txt': '#15170F', '--resalte-bg': '#D9F24F', '--resalte-txt': '#15170F' } }
  };
  let id = null;
  try { id = new URLSearchParams(location.search).get('paleta'); } catch (e) {}
  try { if (id) localStorage.setItem('mk-paleta2', id); else id = localStorage.getItem('mk-paleta2'); } catch (e) {}
  if (!PALETAS[id]) id = 'brandbook';
  const root = document.documentElement;
  Object.entries(PALETAS[id].vars).forEach(([k, v]) => root.style.setProperty(k, v));
  root.dataset.paleta = id;

  // aviso del borrador: muestra la gama activa y deja cambiarla
  document.addEventListener('DOMContentLoaded', () => {
    const d = document.getElementById('draft');
    if (!d) return;
    const p = document.createElement('span');
    p.style.cssText = 'display:block;margin-top:.35rem';
    p.innerHTML = '<b>Paleta (manual de marca):</b> ' + MODELOS.map(k => [k, PALETAS[k]]).map(([k, v]) =>
      k === id ? `<u>${v.nombre}</u>` : `<a href="?paleta=${k}" style="color:inherit">${v.nombre}</a>`).join(' · ');
    d.appendChild(p);
  });
})();
